import type { ComponentChildren } from 'preact'
import styles from './index.module.css'

export function TransparentButton({
  children,
  onClick,
  className,
  id,
}: {
  children: ComponentChildren
  onClick: () => void
  className?: string
  id?: string
}) {
  return (
    <button id={id} class={`${styles.button} ${className ?? ''}`} onClick={onClick} type="button">
      {children}
    </button>
  )
}
